// extracted by mini-css-extract-plugin
export var mt0 = "sections-module--mt-0--a3d2d";
export var mt1 = "sections-module--mt-1--d31fc";
export var mt2 = "sections-module--mt-2--50b0c";
export var mt3 = "sections-module--mt-3--14e5d";
export var mt4 = "sections-module--mt-4--33185";
export var mt5 = "sections-module--mt-5--a5f4e";
export var mt6 = "sections-module--mt-6--74817";
export var sections__body = "sections-module--sections__body--1143d";
export var sections__breadcrumbs = "sections-module--sections__breadcrumbs--99dab";